import { AlertContext, Loading, Separator } from "@moreirapontocom/npmhelpers";
import { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { DataContext } from "../../context/Data.context";
import dayjs from "dayjs";

import "./Home.scss";

const Home = () => {
  const { setAlert } = useContext(AlertContext);
  const { data, setData } = useContext(DataContext);
  const navigate: any = useNavigate();

  useEffect(() => {
    setData({
      ...data,
      pageHeader: {
        title: "Metrix Reader",
        backButton: false,
      },
      hideNavbar: false,
    });

    _getResults();
  }, []);

  const [results, setResults] = useState([] as any[]);
  const _getResults = () => {
    const storageKey = "results";
    const resultsStorage: any = localStorage.getItem(storageKey);
    if (resultsStorage) {
      const results: any = JSON.parse(resultsStorage);
      results.sort((a: any, b: any) => a.timestamp > b.timestamp ? -1 : 1);
      setResults(results);
      return;
    }
  };

  return <>
    <div className="row align-items-center">
      <div className="col-3 text-center">
        <i className="fas fa-user-circle fa-4x"></i>
      </div>
      <div className="col">
        <h4>
          <strong>John Smith</strong>
        </h4>
        <small className="text-muted">
          June 1, 1980
        </small>
      </div>
    </div>

    <Separator size={40} />

    <div className="d-grid">
      <Link to="/newTest" className="btn btn-primary btn-featured">New Test</Link>
    </div>

    <Separator size={20} />

    {results.length === 0 && <>
      <div className="text-center">
        <strong>No results found</strong>
      </div>
    </>}

    {results.length > 0 && <>
      <small className="text-muted">{results.length} results</small>

      <Separator size={10} />

      <ul className="list-group">
        {results.map((result: any, index: number) => {
          return (
            <li
              onClick={() => result.isRunning ? setAlert({ type: "danger", message: "Test is running" }) : navigate(`/result/${result.id}`)}
              key={`result-${result.readerId}-${index}`}
              className={`list-group-item ${!result.isRunning && "cursor-pointer"}`}>

                <div className="row align-items-center">
                  <div className="col-2">

                    <div className="text-center">
                      <Loading loading={result.isRunning} parent="inline" color="text-featured" />
                    </div>

                    {!result.isRunning && <>
                      <img src={`images/icon-result-${result.result}.png`} alt="" className="img-fluid rounded" />
                    </>}
                  </div>
                  <div className="col">
                    <strong>
                      <span className="text-uppercase">{result.sensorType || ""} &middot; {result.isRunning ? <span className="text-muted">Test in progress...</span> : result.result}</span>
                    </strong>
                    <br />
                    <small className="text-muted">
                      Device Serial Number: {result.readerSerialNumber || ""}<br />
                      Test Date: {dayjs(result.timestamp).format("MM/DD/YYYY HH:mm:ss") || ""}
                      {result.reported && <>
                        <br />
                        <span className="text-success">
                          <i className="fas fa-check text-success me-2"></i> Report sent
                        </span>
                      </>}
                    </small>
                  </div>
                  <div className="col-1 text-end">
                    {!result.isRunning && <i className="fas fa-chevron-right"></i>}
                  </div>
                </div>
            </li>
          )
        })}
      </ul>

      <Separator size={160} />
    </>}
  </>
};

export default Home;